const fontUrl =
  'https://res.cloudinary.com/dgg9enyjv/raw/upload/v1510650331/Magnet/fonts/'
const magnetFonts = `
@font-face {
  font-family: 'Campton';
  src: url(${fontUrl}Campton_normal_300.woff2) format("woff2"),
        url(${fontUrl}Campton_normal_300.woff) format("woff");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Campton';
  src: url(${fontUrl}Campton_normal_350.woff) format("woff"),
    url(${fontUrl}Campton_normal_350.woff2) format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Campton';
  src: url(${fontUrl}Campton_normal_500.woff2) format("woff2"),
        url(${fontUrl}Campton_normal_500.woff) format("woff");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Campton';
  src: url(${fontUrl}Campton_normal_700.woff2) format("woff2"),
        url(${fontUrl}Campton_normal_700.woff) format("woff");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'NewSpirit';
  src: url(${fontUrl}NewSpirit-Light.woff2) format("woff2"),
    url(${fontUrl}NewSpirit-Light.woff) format("woff");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: 'NewSpirit';
  src: url(${fontUrl}NewSpirit-Regular.woff2) format("woff2"),
    url(${fontUrl}NewSpirit-Regular.woff) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'NewSpirit';
  src: url(${fontUrl}NewSpirit-Medium.woff2) format("woff2"),
    url(${fontUrl}NewSpirit-Medium.woff) format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: 'NewSpirit';
  src: url(${fontUrl}NewSpirit-SemiBold.woff2) format("woff2"),
    url(${fontUrl}NewSpirit-SemiBold.woff) format("woff");
  font-weight: 600;
  font-style: normal;
}
`

export default magnetFonts
